export enum Error {
    UserNotFoundException = 'UserNotFoundException',
}
